import { getCopyPortfoliosStuck } from "@/controllers/gridManager/followerTransManager/followerTransManager";
import TableUIActionInputElement from "@/views/components/componentsUI/TableUIActionInputElement";
import { Column } from "@/views/components/componentsUI/TableUIActionInputElement";
import { KeyDataParents, DataOnParents } from "./SellStuckStocks";
import { useCosInfo } from "@/controllers/gridManager/accountsManager/accountManager";
import { useTranslation } from "react-i18next";

type PropsStep = {
    close: () => void,
    back: () => void,
    next: () => void,
    handleSaveDataOnParents: (key: KeyDataParents, data: {}) => void
    dataOnParents: DataOnParents,
    masterAccount: string
}

export default function Step1({
    back, next, handleSaveDataOnParents, dataOnParents, masterAccount, close

}: PropsStep) {
    const { t } = useTranslation()
    const { cosInfo } = useCosInfo()
    const { refaccount } = cosInfo
    const { Step1 } = dataOnParents


    const columns: Column[] = [
        { id: 'symbol', label: t("copytrade.common.symbol"), width: 150, enableSort: true },
        { id: 'qttyInput', label: t("copytrade.sellStuckStocks.orderQtty"), width: 300, inputRender: true, alignCell: 'right', align: 'right' },
        { id: 'priceInput', label: t("copytrade.sellStuckStocks.orderPrice"), width: 300, inputRender: true, alignCell: 'right', align: 'right' },
        { id: 'Giá trị lệnh', label: t("copytrade.sellStuckStocks.valueOrder"), width: 220, cellFormula: ('qttyInput*priceInput'), formatNumber: true, enableSort: true, alignCell: 'right', align: 'right' },
        { id: '%Lãi/Lỗ', label: t("copytrade.common.ppnl"), width: 150, formatNumber: true, enableSort: true, alignCell: 'right', align: 'right' },
    ];


    const objParameterFn: Partial<Parameters<typeof getCopyPortfoliosStuck>[0]> = {
        accountId: refaccount,
        masterAccount: masterAccount ?? '',
        pageIndex: 1,
        pageSize: 9999
    }

    return (
        <TableUIActionInputElement
            columns={columns}
            fnCallApi={getCopyPortfoliosStuck}
            objParameterFn={objParameterFn}
            enableDatePicker={false}
            supportPagination={false}
            listenerQuery={{ currentMasterAccount: masterAccount }}

            supportCheckBox={true}
            rowKey="symbol"
            isSupportInstrument={true}
            setSelectedDataToParent={handleSaveDataOnParents}
            prevData={Step1}
            actionArea={true}
            close={close}
            next={next}
        />
    )
}